module.exports = __webpack_public_path__ + "img/medical_physical_02.0c3faecd.jpg";